import React from "react";
import { NewsData } from "../../../../lib/types";
import { NEWS_DETAIL } from "../../../../lib/enums";
import { formatNumber } from "../../../../lib/commonFunctions";

interface IProps {
  round: NewsData;
}

const NewsPersonMelee = ({
  round
}: IProps) => {
  if (!round) {
    return <></>
  }

  const parts = round.details[NEWS_DETAIL.MeleeTurnsDetails] && round.details[NEWS_DETAIL.MeleeTurnsDetails].value.split("|");
  const names = parts[0]?.split(":");
  const damage = parts[1]?.split(":");

  return (
    <div>
      <p className={"text-info"}>Melee phase</p>
      <em>{names[0]}</em>&nbsp;
      <i
        className={`icon icon-utok middle ${damage && Number.parseFloat(damage[0]) > 0 ? " positive" : " negative"}`}/>
      &nbsp;
      <em>{names[1]}</em>
      <div style={{ paddingTop: "7px", paddingBottom: "7px" }}>
        <div>
          Damage: <em>{formatNumber(parseInt(damage[0], 10))}</em>
        </div>
      </div>
      <em>{names[1]}</em>&nbsp;
      <i
        className={`icon icon-utok middle ${damage && Number.parseFloat(damage[1]) > 0 ? " positive" : " negative"}`}/>
      &nbsp;
      <em>{names[0]}</em>
      <div style={{ paddingTop: "7px", paddingBottom: "7px" }}>
        <div>
          Damage: <em>{formatNumber(parseInt(damage[1], 10))}</em>
        </div>
      </div>
    </div>
  )
}

export default NewsPersonMelee;
